import type { UserId } from '../shared/ids';
import type { Organization, OrgMember } from './organization';

/**
 * Every operation names the user it acts for. The identity is an input the
 * caller already holds (the signed-in user a store keyed its data on), never
 * something the repository looks up at call time.
 */
export abstract class OrganizationRepository {
  abstract forUser(userId: UserId): Promise<{
    orgs: readonly Organization[];
    memberships: readonly OrgMember[];
  }>;
}
